<template>
  <div>
    <v-card>
      <v-card-title
        class="pb-0 justify-space-between"
        style="font-size:18px;font-weight:bold;"
        >New option form</v-card-title
      >
      <v-form ref="formOption" v-model="valid" class="px-4">
        <v-layout row wrap class="pa-1">
          <v-flex xs4 class="pr-2">
            <v-text-field
              v-model="form_option.option_name_th"
              label="Option name TH"
              hide-details
              :rules="[(v) => !!v || 'name is required']"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="px-2">
            <v-text-field
              v-model="form_option.option_name_en"
              label="Option name EN"
              hide-details
              :rules="[(v) => !!v || 'name is required']"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="pl-2">
            <v-text-field
              v-model="form_option.option_name_cn"
              label="Option name CN"
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="my-4">
          <v-flex>
            <v-radio-group
              v-model="form_option.option_type"
              row
              class="mt-0"
              hide-details
              :rules="[(v) => !!v || 'name is required']"
            >
              <div class="mr-2">Option Type :</div>
              <v-radio color="black" label="Single" :value="1"></v-radio>
              <v-radio color="black" label="Multiple" :value="2"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex>
            <v-checkbox
              v-model="form_option.option_require"
              class="mt-0 ml-3"
              label="Required this option."
              color="green"
              hide-details
            ></v-checkbox>
          </v-flex>
        </v-layout>

        <div v-for="(info, index) in form_option.option_choice" :key="index">
          <v-layout row wrap>
            <v-flex xs6 sm3 class="pa-1">
              <v-text-field
                class="mb-2"
                v-model="info.choice_name_th"
                label="Choice Name TH"
                outline
                hide-details
                :rules="[(v) => !!v || 'name is required']"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm3 class="pa-1">
              <v-text-field
                class="mb-2"
                outline
                v-model="info.choice_name_en"
                label="Choice Name EN"
                hide-details
                :rules="[(v) => !!v || 'name is required']"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm3 class="pa-1">
              <v-text-field
                outline
                v-model="info.choice_name_cn"
                label="Choice Name CN"
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs5 sm2 class="pa-1">
              <v-text-field
                v-model="info.choice_price"
                outline
                label="Price"
                hide-details
                :rules="[(v) => !!v || 'name is required']"
              ></v-text-field>
            </v-flex>
            <v-flex xs1 class="text-xs-center">
              <v-icon
                v-if="index == 0"
                medium
                color="green"
                style="padding-top:20px;"
                @click="addChoice()"
                >add_circle</v-icon
              >
              <v-icon
                v-if="index != 0"
                medium
                color="red"
                style="padding-top:20px;"
                @click="delChoice(index)"
                >remove_circle</v-icon
              >
            </v-flex>
          </v-layout>
        </div>

        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn depressed @click="$emit('cancel')">Cancel</v-btn>
          <v-btn depressed @click="save()">Save</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["form_option", "editedIndex"],
  data() {
    return {
      valid: true,
    };
  },
  computed: {
    ...mapGetters(["isEditProductList"]),
  },
  methods: {
    stringEmptyToNull(form) {
      for (let val in form) {
        if (typeof form[val] == "string" && form[val] == "") {
          form[val] = null;
        }
        if (typeof form[val] == "object" && form[val] != null) {
          for (let arr in form[val]) {
            for (let val1 in form[val][arr]) {
              if (
                typeof form[val][arr][val1] == "string" &&
                form[val][arr][val1] == ""
              ) {
                form[val][arr][val1] = null;
              }
              if (
                typeof form[val][arr][val1] == "object" &&
                form[val][arr][val1] != null
              ) {
                for (let arr2 in form[val][arr][val1]) {
                  for (let val2 in form[val][arr][val1][arr2]) {
                    if (
                      typeof form[val][arr][val1][arr2][val2] == "string" &&
                      form[val][arr][val1][arr2][val2] == ""
                    )
                      form[val][arr][val1][arr2][val2] = null;
                  }
                }
              }
            }
          }
        }
      }
      return form;
    },
    addChoice() {
      this.form_option.option_choice.push({});
    },
    delChoice(index) {
      this.form_option.option_choice.splice(index, 1);
    },
    async save() {
      if (this.$refs.formOption.validate()) {
        if (this.editedIndex == -1) {
          this.$emit("save", null);
        } else {
          this.form_option = await this.stringEmptyToNull(this.form_option);
          let data = await this.$store.dispatch(
            "fetchProductListBack/addEditOption",
            this.form_option
          );
          if (data != false) {
            this.$emit("save", data);
          }
        }
      }
    },
  },
};
</script>

<style></style>
